<div class="modal-header">
    <div class="col-10">
        <span class="widget-title text-blue text-125">Ventas No Contabilizadas</span>
    </div>
    <div class="col-md-2 col-xs-2">
        <button class="btn btn-danger" type="button" (click)="cerrarComponente()">
            <i class="ace-icon fa fa-times red2 align-top bigger-110"></i>
        </button>
    </div>
</div>
<div class="modal-body">
      <div class="bootstrap-table bootstrap4">
        <div class="fixed-table-container" style="padding-bottom: 0px;">
          <div class="fixed-table-header" style="display: none;">
            <table></table>
          </div>
          <div class="table-responsive table-fixed-header" style="height: 450px;">
            <div class="fixed-table-loading table table-bordered table-hover" style="top: 46.6167px;">
              <span class="loading-wrap">
                <span class="animation-wrap">
                  <span class="animation-dot"></span>
                </span>
              </span>
            </div>
  
            <table class="table table-striped table-bordered table-hover ">
                <thead fix-head class="table-head-color">
                    <tr>
                        <th>Nº</th>
                        <th>Sucursal</th>
                        <th>Transacción</th>
                        <th>Num. Doc.</th>
                        <th>Fecha</th>
                        <th>Tipo de pago</th>
                        <th>Cliente</th>
                        <th>Total</th>
                        <th>A Cuenta</th>
                        <th>Saldo</th>
                        <th style="text-align: center; width: 140px; " data-field="tools">
                            <div class="th-inner "><i class="fa fa-cog text-secondary-d1 text-130"></i></div>
                            <div class="fht-cell"></div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let venta_no_contabilizada of ventas_no_contabilizadas; let i=index;">
                        <td>{{i+1}}</td>
                        <td>{{venta_no_contabilizada.sucursal.nombre}}</td>
                        <td>{{venta_no_contabilizada.transaccion.nombre}}</td>
                        <td>{{venta_no_contabilizada.factura}}</td>
                        <td>{{venta_no_contabilizada.fecha | date:"dd/MM/yyyy"}}</td>
                        <td>{{venta_no_contabilizada.tipoPago.nombre}}</td>
                        <td>{{venta_no_contabilizada.razon_social}}</td>
                        <td>{{venta_no_contabilizada.total.toFixed(2)}}</td>
                        <td>{{venta_no_contabilizada.a_cuenta.toFixed(2)}}</td>
                        <td>{{venta_no_contabilizada.saldo.toFixed(2)}}</td>
                        <td style="text-align: center; width: 140px; ">
                            <div class="d-lg-inline text-muted">
                                <a title="Contabilizar" *ngIf="venta_no_contabilizada.tipoPago.nombre_corto==global_variable.Dictionary.TIPO_PAGO_CONT || (venta_no_contabilizada.tipoPago.nombre_corto==global_variable.Dictionary.TIPO_PAGO_CRE && venta_no_contabilizada.saldo==0) || (venta_no_contabilizada.tipoPago.nombre_corto==global_variable.Dictionary.TIPO_PAGO_CRE && venta_no_contabilizada.cliente.cuenta_contabilidad)" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-success btn-a-outline-success btn-text-success" href="javascript:void(0)" (click)="generarNuevoComprobanteVenta(venta_no_contabilizada)">
                                    <i class="fas fa-sign-in-alt"></i>
                                </a>
                                <a title="Asignar Cuenta" *ngIf="venta_no_contabilizada.tipoPago.nombre_corto==global_variable.Dictionary.TIPO_PAGO_CRE && !venta_no_contabilizada.cliente.cuenta_contabilidad && venta_no_contabilizada.saldo>0" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-danger btn-a-outline-danger btn-text-danger" href="javascript:void(0)" (click)="abrirAsignacionCuentaCliente(venta_no_contabilizada.cliente)">
                                    <i class="fas fa-question"></i>
                                </a>
                                <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-danger btn-a-outline-danger btn-text-danger" href="javascript:void(0)" (click)="abrirPopupConfirmacionEliminacion(venta_no_contabilizada)">
                                  <i class="fa fa-trash-alt"></i>
                                </a>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
              
          </div>
          <div class="fixed-table-footer">
            <table><thead><tr></tr></thead></table>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
</div>